"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const context = __importStar(require("./context"));
const core = __importStar(require("@actions/core"));
const actionsToolkit = __importStar(require("@docker/actions-toolkit"));
const docker_1 = require("@docker/actions-toolkit/lib/docker");
const exec_1 = require("@docker/actions-toolkit/lib/exec");
actionsToolkit.run(
// main
() => __awaiter(void 0, void 0, void 0, function* () {
    const input = context.getInputs();
    yield core.group(`Docker info`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield docker_1.Docker.printVersion();
        yield docker_1.Docker.printInfo();
    }));
    yield core.group(`Pulling binfmt Docker image`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield exec_1.Exec.exec('docker', ['pull', input.image]);
    }));
    yield core.group(`Image info`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield exec_1.Exec.exec('docker', ['image', 'inspect', input.image]);
    }));
    yield core.group(`Installing QEMU static binaries`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield exec_1.Exec.exec('docker', ['run', '--rm', '--privileged', input.image, '--install', input.platforms]);
    }));
    yield core.group(`Extracting available platforms`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield exec_1.Exec.getExecOutput('docker', ['run', '--rm', '--privileged', input.image], {
            ignoreReturnCode: true,
            silent: true
        }).then(res => {
            if (res.stderr.length > 0 && res.exitCode != 0) {
                throw new Error(res.stderr.trim());
            }
            const platforms = JSON.parse(res.stdout.trim());
            core.info(`${platforms.supported.join(',')}`);
            core.setOutput('platforms', platforms.supported.join(','));
        });
    }));
}));
